export default "__VITE_ASSET__d5eba140__"